import React, { useRef, useEffect, useState } from 'react';
import "../styles/global.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract, faBuilding, faBalanceScale } from '@fortawesome/free-solid-svg-icons'; // Importuj ikony
import logoPattern from '../assets/Karolplank2.png';

export default function HomePage() {
  const carouselRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [cardWidth, setCardWidth] = useState(0);
  const [visibleCards, setVisibleCards] = useState(0);

  const hlavneSluzby = [
    { nazov: 'Zmluvná agenda', popis: 'Právne poradenstvo pri príprave a pripomienkovaní zmluvnej dokumentácie', icon: faFileContract },
    { nazov: 'Sporová agenda', popis: 'Komplexné právne zastupovanie fyzických a právnických osôb pred všeobecnými súdmi v SR a rozhodcovskými súdmi', icon: faBuilding },
    { nazov: 'Korporátna agenda', popis: 'Zakladanie a zmeny obchodných spoločností, registrácia v RPVS', icon: faBalanceScale },
  
   
    
  ];

  return (
    <main className="container homepage">
      <section className="hero">
        <div className="hero-overlay">
          <h1> Individuálny prístup, <br/>odborné a efektívne riešenia.</h1>
          <Link to="/kontakt" className="btn-primary">Kontaktujte nás</Link>
        </div>
      </section>

      <section className="services">
        <h2 className="section-title">Hlavné služby</h2>
        <div className="hlavne-sluzby-grid">
          {hlavneSluzby.slice(0, 4).map((sluzba, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <FontAwesomeIcon icon={sluzba.icon} />
              </div>
              <h3>{sluzba.nazov}</h3>
              <p>{sluzba.popis}</p>
            </div>
          ))}
        </div>
        <Link to="/specializacia" className="btn-secondary">Všetky služby</Link>
      </section>

      <section className="counters">
        <div>
          <strong>10+</strong>
          <span>rokov praxe</span>
        </div>
        <div>
          <strong>200+</strong>
          <span>klientov</span>
        </div>
        <div>
          <strong>1500+</strong>
          <span>hodín na súde</span>
        </div>
      </section>
      <section className="cta-section" >
        <div className="cta-overlay">
          <h2>Potrebujete právnu pomoc?</h2>
          <p>Kontaktujte nás pre dohodnutie konzultácie alebo získanie ďalších informácií.</p>

          <Link to="/kontakt" className="btn-primary cta-button">Kontaktujte nás</Link>
          {/* Voliteľné: Formulár pre telefónne číslo */}
          {/* <div className="phone-form">
            <input type="tel" placeholder="Vaše telefónne číslo" />
            <button className="btn-secondary">Odoslať</button>
          </div> */}
        </div>
      </section>
    </main>
  );
}